export default __webpack_public_path__ + "static/media/privacy.3253d6c3.jpg";